// firebaseConfig.ts
import { initializeApp } from "firebase/app";
import { getAuth, GoogleAuthProvider } from "firebase/auth";

const firebaseConfig = {
    apiKey: "AIzaSyBr365v4b2bX3rAxt3Dh8OXsYaHvv1Zm3A",
    authDomain: "nexum-chatbot-294014.firebaseapp.com",
    databaseURL: "https://nexum-chatbot-294014.firebaseio.com",
    projectId: "nexum-chatbot-294014",
    storageBucket: `${process.env.REACT_APP_STORAGE_BUCKET}`,
    messagingSenderId: "828621662226",
    appId: "1:828621662226:web:6c88466e9aac81eda450cb"
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);

// Initialize Firebase Auth
const auth = getAuth(app);
const googleProvider = new GoogleAuthProvider();

export { auth, googleProvider };
